import { CREATE_SURGE_EVENT, CREATE_SURGE_EVENT_SUCCESS, CREATE_SURGE_EVENT_ERROR, CREATE_SURGE_EVENT_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateEvent = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SURGE_EVENT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_SURGE_EVENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: action?.payload?.message,
      };
      break;

    case CREATE_SURGE_EVENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_SURGE_EVENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateEvent;
